<template>
  <div class="swiper-container">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="(item,index) in files" :key="index">
        <!-- <img :src="item" /> -->
        <div class="box">
          <img :src="item" />
        </div>
      </div>
    </div>
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
    <div class="swiper-pagination"></div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  name: "DynBanner",
  data() {
    return {
      src: []
    };
  },
  created() {
    this.gainSrc();
    this.gainSrc();
    let screenWidth = document.documentElement.clientWidth;
    if (screenWidth < 600) {
      let item;
      item = this.files[0];
      this.files[0] = this.files[1];
      this.files[1] = item;
    }
  },
  computed: {
    files() {
      var container = [];
      for (let item of this.src) {
        container.push(require("./images" + item));
      }
      return container;
    }
  },
  mounted() {
    var swiper = new Swiper(".swiper-container", {
      effect: "coverflow",
      grabCursor: true,
      loop: true,
      speed: 2000,
      autoplay: true,
      slidesPerView: "auto",
      coverflowEffect: {
        rotate: 50,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: true
      },
      pagination: {
        el: ".swiper-pagination"
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    });
  },
  methods: {
    gainSrc() {
      var files = require
        .context("./images", false, /.(png|jpg|jpeg|gif|bmp|webp)$/)
        .keys();
      this.src = files.map(item => item.replace(".", ""));
    }
  }
};
</script>

<style scoped>
.swiper-container {
  width: 55rem;
  padding-top: 50px;
  padding-bottom: 50px;
}
.swiper-slide {
  background-position: center;
  background-size: cover;
  width: 18.75rem;
  height: 18.75rem;
}
@media screen and (max-width: 472px) {
  .swiper-container {
    width: 85%;
  }
}
@media screen and (max-width: 992px) {
  .swiper-container {
    width: 90%;
  }
}
/* @media screen and (min-width:694px) { */
.box {
  position: relative;
  background-color: red;
  overflow: hidden;
}
.box img {
  width: 100%;
  border: 0;
}
.box:after {
  position: absolute;
  right: -200%;
  top: 0;
  width: 200%;
  height: 100%;
  content: "";
  transform: skewX(45deg);
  background: -webkit-linear-gradient(
    right,
    rgba(255, 255, 255, 0) 0,
    rgba(255, 255, 255, 0.7) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  background: -o-linear-gradient(
    right,
    rgba(255, 255, 255, 0) 0,
    rgba(255, 255, 255, 0.7) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  background: -moz-linear-gradient(
    right,
    rgba(255, 255, 255, 0) 0,
    rgba(255, 255, 255, 0.7) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  background: linear-gradient(
    to left,
    rgba(255, 255, 255, 0) 0,
    rgba(255, 255, 255, 0.7) 50%,
    rgba(255, 255, 255, 0) 100%
  );
}
.box:hover:after {
  right: 150%;
  transition: 1s ease;
}
.box:hover img {
  transform: scale(1.2);
  transition: all 1s ease 0s;
  -webkit-transform: scale(1.2);
  -webkit-transform: all 1s ease 0s;
}
/* } */
</style>
